import Layout from '@/layout'

export default {
  path: '/customers',
  redirect: '/bank_accounts/list',
  component: Layout,
  children: [
    {
      path: 'list',
      name: 'お得意先',
      component: () => import('@/views/customer')
    },
    {
      path: 'new',
      name: '新規お得意先',
      component: () => import('@/views/customer/edit')
    },
    {
      path: 'show/:id',
      name: 'お得意先詳細',
      component: () => import('@/views/customer/show')
    },
    {
      path: 'edit/:id',
      name: 'お得意先情報編集',
      component: () => import('@/views/customer/edit')
    }

  ]
}
